
const RULE_MAP = {
  required: value => !!value || 'Required.',
  positiveNumber: value => value === null || value === undefined || value === '' || Number(value) > 0 || 'Must be greater than 0.',
  counter: value => value.length <= 20 || 'Max 20 characters',
  email: (value) => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return pattern.test(value) || 'Invalid e-mail.'
  }
}

const REQUIRED_MESSAGE = 'Required.'

function hasValue (value) {
  if (value === null || value === undefined) {
    return false
  }
  if (typeof value === 'boolean') {
    return value
  }
  if (typeof value === 'number') {
    return !Number.isNaN(value)
  }
  if (typeof value === 'string') {
    return value.trim().length > 0
  }
  if (Array.isArray(value)) {
    return value.length > 0
  }
  if (typeof value === 'object') {
    return Object.keys(value).length > 0
  }
  return true
}

function requiredIf (formData, field, message) {
  return (value) => {
    if (!formData || !field) {
      return true
    }
    const otherValue = formData[field]
    if (hasValue(otherValue)) {
      return hasValue(value) || message || REQUIRED_MESSAGE
    }
    return true
  }
}

function contactIdentity (formData, message) {
  return () => {
    if (!formData) {
      return true
    }

    return hasValue(formData.company) || hasValue(formData.last_name) || message || 'Enter a company or last name.'
  }
}

function dateOnOrAfter (formData, field, message) {
  return (value) => {
    if (!hasValue(value) || !formData || !field || !hasValue(formData[field])) {
      return true
    }

    const currentDate = new Date(`${value}T00:00:00`)
    const compareDate = new Date(`${formData[field]}T00:00:00`)

    if (Number.isNaN(currentDate.getTime()) || Number.isNaN(compareDate.getTime())) {
      return true
    }

    return currentDate >= compareDate || message || 'Date is before the allowed date.'
  }
}

export function getRule (rule, formData) {
  if (typeof rule === 'string') {
    if (rule.startsWith('requiredIf:')) {
      const field = rule.slice('requiredIf:'.length).trim()
      return requiredIf(formData, field)
    }
    return RULE_MAP[rule]
  }

  if (rule && typeof rule === 'object') {
    if (rule.type === 'requiredIf') {
      return requiredIf(formData, rule.field, rule.message)
    }
    if (rule.type === 'contactIdentity') {
      return contactIdentity(formData, rule.message)
    }
    if (rule.type === 'dateOnOrAfter') {
      return dateOnOrAfter(formData, rule.field, rule.message)
    }
    return RULE_MAP[rule.type]
  }

  return undefined
}

export default {
  getRule
}
